<template>
    <div :id="id" class="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="h5 modal-title"><i class="fa" :class="determineIcon()" aria-hidden="true"></i> {{ title }}</h5>
            <i v-if="dialogType == 'Dialog'" class="fa fa-times text-md ms-3 cursor-pointer" @click="emitClose"/>
          </div>
          <div class="pt-4 modal-body">
            <div class="mb-4 input-group">
                <h5>{{ body }}</h5>
                <slot></slot>
            </div>
            <div class="text-end">
              <button
                class="m-1 btn btn-primary"
                @click="emitOk"
              >
                {{ okButtonLabel }}
              </button>
              <button
                v-if="dialogType != 'Alert'"
                class="m-1 btn btn-secondary"
                @click="emitClose"
              >
                {{ cancelButtonLabel }}
              </button>
            </div>
          </div>
        </div>
        <div
          :id="id + '-backdrop'"
          class="fixed inset-0 z-40 hidden bg-black opacity-50"
        ></div>
      </div>
    </div>
</template>

<script>
let modal;
export default {
  name: "Modal",
  emits: ['close','save'],
  components: {
  },
  props: {
    id: {
      type: String,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    },
    title: {
        type: String,
        default: "My Modal"
    },
    body: {
        type: String,
        default: ""
    },
    okButtonLabel: {
        type: String,
        default: "Aceptar"
    },
    cancelButtonLabel: {
        type: String,
        default: "Cancelar"
    },
    dialogType: {
      type: String,
      default: "Dialog"
    }
  },
  
  watch: {
    show(newVal) {
        if(modal) newVal ? modal.show() : modal.hide();
    }
  },
  mounted() {
    const bootstrap = this.$store.state.bootstrap;
    modal = new bootstrap.Modal(document.getElementById(this.id), {
        show: true,
        backdrop: 'static',
        keyboard: false
    });
  },
  methods: {
    emitClose() {
        this.$emit('close');
    },
    emitOk() {
        if(this.dialogType == 'Alert') this.$emit('close')
        else this.$emit('save');
    },
    determineIcon() {
        if(this.dialogType == 'Dialog')
            return 'fa-pencil-square-o';
        if(this.dialogType == 'Alert')
            return 'fa-exclamation-triangle';
        if(this.dialogType == 'Info')
            return 'fa-info-circle';
        if(this.dialogType == 'Confirmation')
            return 'fa-question-circle-o';
    }
  },
};
</script>
